import axios from 'axios';

const BASE_URL = 'https://api-aidsistant.rubythalib.ai';
// const BASE_URL = 'http://143.198.213.67';
// const BASE_URL = 'http://localhost:8000';

const apiService = axios.create({
  baseURL: BASE_URL,
  timeout: 10000
});

apiService.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

apiService.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response) {
    // The request was made and the server responded with a status code that falls out of the range of 2xx
    console.error('Response error:', error.response.data);
    console.error('Response status:', error.response.status);
    console.error('Response headers:', error.response.headers);
    if (error.response.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
  } else if (error.request) {
    // The request was made but no response was received
    console.error('Request error:', error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error('Error', error.message);
  }
  return Promise.reject(error);
});

export default apiService;
